module.exports = "<div class=\"error-block\">\n    <p class=\"error-code\">404<p>\n    <p class=\"error-text\">We couldn't find the page you requested</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/common/not-found/not-found.html
// module id = tkL+
// module chunks = 0